import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const getConfig = asyncActionsCreator(constants.GET_CONFIG);
export const setConfig = asyncActionsCreator(constants.SET_CONFIG);
export const getCardPayment = asyncActionsCreator(constants.GET_CARD_PAYMENT);
export const setCardPayment = asyncActionsCreator(constants.SET_CARD_PAYMENT);
export const getGlovoEnabledStatus = asyncActionsCreator(
  constants.GET_GLOVO_ENABLED_STATUS
);
export const setEnambleGlovo = asyncActionsCreator(constants.SET_ENABLE_GLOVO);
export const setDisableGlovo = asyncActionsCreator(constants.SET_DISABLE_GLOVO);
export const setWoltEnabled = asyncActionsCreator(constants.SET_WOLT_ENABLED);
export const setDeliveryProviderEnabled = asyncActionsCreator(
  constants.SET_DELIVERY_PROVIDER_ENABLED
);
export const getDeliveryProviders = asyncActionsCreator(
  constants.GET_DELIVERY_PROVIDERS
);
